(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6212"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6212"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d2DXp", function(module, exports) {

$parcel$export(module.exports, "moveUpElements", function () { return $97ea74f22d49336e$export$92b2264c78c41f3a; });

var $gF48i = parcelRequire("gF48i");
const $97ea74f22d49336e$export$92b2264c78c41f3a = ()=>{
    // const content = document.querySelector(".content-wrapper");
    const moveup = document.querySelectorAll(".has-moveup-attribute");
    // function hasContentWrapperParent(element) {
    // 	if (element.previousSibling && element.previousSibling.parentNode) {
    // 		console.log(element);
    // 		if (
    // 			element.previousSibling.parentNode.classList.contains(
    // 				"content-wrapper"
    // 			)
    // 		) {
    // 			return element.previousSibling;
    // 		} else {
    // 			return hasContentWrapperParent(element.previousSibling.parentNode);
    // 		}
    // 	} 
    // 	return false;
    // }
    //em = px / font-size (default is 16px).
    moveup.forEach(function(item) {
        const translateNumber = parseInt(item.getAttribute("data-moveup"));
        const translateNumberRem = (0, $gF48i.default)(translateNumber);
        const elementMarginBottom = parseFloat(getComputedStyle(item).marginBottom);
        item.style.transform = `translateY(-${translateNumberRem}rem)`;
        item.style.marginBottom = -translateNumberRem + (0, $gF48i.default)(elementMarginBottom) + "rem";
        const sibling = item.previousElementSibling;
        if (sibling) {
            item.previousElementSibling.classList.add("moveup-previous");
            const previousPadding = parseFloat(getComputedStyle(item.previousElementSibling).paddingBottom);
            if (previousPadding != 0) item.previousElementSibling.style.paddingBottom = (0, $gF48i.default)(previousPadding) + translateNumberRem + "rem";
            else item.previousElementSibling.style.paddingBottom = translateNumberRem + "rem";
        }
    });
// if (content) {
// 	const firstElement = content.firstElementChild;
// 	if (firstElement.classList.contains("hero") === true) {
// 		document
// 			.querySelector(".site-header")
// 			.classList.add("color-light");
// 	}
// 	if (firstElement.classList.contains("hero-overlay-active") === true) {
// 		document
// 			.querySelector(".site-header")
// 			.classList.add("color-light-logo");
// 	}
// }
};

});
parcelRegister("gF48i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c213ae582cc7a65d$export$2e2bcd8739ae039; });
const $c213ae582cc7a65d$var$pxToEm = (number)=>{
    return number / parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--wp--preset--font-size--normal"));
};
var $c213ae582cc7a65d$export$2e2bcd8739ae039 = $c213ae582cc7a65d$var$pxToEm;

});



const $e892be5f587a3385$var$menuSticky = ()=>{
    const header = document.querySelector(".fixed-header");
    const navBar = document.querySelector(".nav-sticky");
    const adminBar = document.querySelector("#wpadminbar");
    if (adminBar && navBar) navBar.style.top = adminBar.offsetHeight + "px";
    if (navBar) {
        header.style.height = navBar.offsetHeight + "px";
        // apply initial height
        let navPosition = navBar.offsetTop;
        if (window.scrollY > navPosition) header.classList.add("sticky");
        else header.classList.remove("sticky");
    }
};
var $e892be5f587a3385$export$2e2bcd8739ae039 = $e892be5f587a3385$var$menuSticky;


const $706c7076a3e32a08$var$menuToggle = ()=>{
    const navbarToggler = document.querySelectorAll(".toggler-menu-js");
    navbarToggler.forEach((toggler)=>{
        toggler.addEventListener("click", (e)=>{
            e.preventDefault();
            document.querySelector("html").classList.toggle("menu-open");
            navbarToggler.forEach((toggler)=>{
                toggler.classList.toggle("is-active");
            });
        });
    });
};
var $706c7076a3e32a08$export$2e2bcd8739ae039 = $706c7076a3e32a08$var$menuToggle;


var $f30575c549086bca$exports = {};
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    "use strict";
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                "MSIE ",
                "Trident/",
                "Edge/"
            ];
            return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === undefined || firstArg.behavior === "auto" || firstArg.behavior === "instant") // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === "object" && firstArg.behavior === "smooth") // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
            return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
            var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === "number" && arguments[1] === undefined) throw new SyntaxError("Value could not be converted");
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        };
    }
    // commonjs
    $f30575c549086bca$exports = {
        polyfill: polyfill
    };
})();


// ---------------------------//
//   ===== GO TO SECTION ====
// ---------------------------//
const $8965c4039d499022$var$goToAnchor = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($f30575c549086bca$exports))).polyfill();
    const allAnchorLinks = document.querySelectorAll("a[href*=\\#]");
    const stickyOffset = document.querySelector(".fixed-header");
    if (allAnchorLinks.length) for (const anchorLink of allAnchorLinks)anchorLink.addEventListener("click", (e)=>{
        let windowUrl = window.location.href.split("#")[0];
        let url = e.currentTarget.href.split("#");
        let baseUrl = url[0];
        let hash = url[1];
        //si l'element est sur une autre page
        if (baseUrl === windowUrl && hash !== "tarteaucitron") {
            e.preventDefault();
            anchorHref(baseUrl, hash, e);
        }
    });
    const anchorHref = (url, hash, event)=>{
        //si on ne clique pas sur tarte au citron
        let positionEl = "";
        let offset = stickyOffset.offsetHeight - 1;
        const anchorID = document.getElementById(hash);
        if (anchorID != null) {
            positionEl = anchorID.offsetTop;
            scroll({
                top: positionEl - offset,
                behavior: "smooth"
            });
        } else {
            // si l'ancre ne se trouve pas sur la page
            console.info("l'identifiant n'a pas \xe9t\xe9 trouv\xe9, on redirige sur l'url");
            document.location.href = url;
        }
    };
    if (window.location.hash.length !== 0) {
        let hash = window.location.hash.substring(1);
        if (hash !== "tarteaucitron") anchorHref(window.location.href, hash);
    }
};
var $8965c4039d499022$export$2e2bcd8739ae039 = $8965c4039d499022$var$goToAnchor;


const $297cb9217e9cf27c$var$headerHeight = ()=>{
    // full height vh without header height
    const header = document.querySelector(".nav-sticky");
    if (header !== null) document.documentElement.style.setProperty("--header-height", header.clientHeight + "px");
};
var $297cb9217e9cf27c$export$2e2bcd8739ae039 = $297cb9217e9cf27c$var$headerHeight;


function $1288651e9b55a7c9$var$getTransitionEndEventName() {
    var transitions = {
        transition: "transitionend",
        OTransition: "oTransitionEnd",
        MozTransition: "transitionend",
        WebkitTransition: "webkitTransitionEnd"
    };
    let bodyStyle = document.body.style;
    for(let transition in transitions){
        if (bodyStyle[transition] != undefined) return transitions[transition];
    }
}
let $1288651e9b55a7c9$var$transitionEndEventName = $1288651e9b55a7c9$var$getTransitionEndEventName();
const $1288651e9b55a7c9$export$96e4b36520c26a2c = ()=>{
    // Quick view ajax function modal content
    const modalButton = document.querySelectorAll("[data-modal='true']");
    let modalAlreadyOpen = false;
    if (modalButton) {
        var modal = document.createElement("div");
        modal.className = "modal";
        // create modal container
        modal.innerHTML = `
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <button type="button" class="modal-close" aria-label="Close">
                        <svg class="icon">
                            <use href="#icon-close"></use>
                        </svg>
                    </button>
                    <div class="modal-body">
					<span class="modal-loader loader"></span>
                    </div>
                </div>
            </div>
        </div>
    `;
        // Append the modal container to the body
        document.body.appendChild(modal);
        modalButton.forEach((item)=>{
            item.addEventListener("click", (event)=>{
                event.preventDefault();
                const postToDisplay = item.querySelector("a").href;
                const modalBody = modal.querySelector(".modal-body");
                // Url de l'ajax wordpress
                const ajaxUrl = modal_ajax.ajax_url;
                // Données à envoyer avec la requête
                const requestData = {
                    posturl: postToDisplay
                };
                // Options de la requête fetch
                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: new URLSearchParams({
                        credentials: "same-origin",
                        action: "ajax_modal_content",
                        data: JSON.stringify(requestData),
                        security: modal_ajax.nonce
                    })
                };
                modal.addEventListener("click", closeModalOutside);
                // si la modal ne vient pas d'être affiché alors
                if (modalAlreadyOpen !== postToDisplay) {
                    //add loader first
                    console.log("load modal");
                    modalBody.innerHTML = '<span class="modal-loader loader"></span>';
                    // Effectuer la requête fetch
                    fetch(ajaxUrl, fetchOptions).then((response)=>response.json()).then((data)=>{
                        // Traiter les données renvoyées par le serveur
                        if (data.success == false) modal.querySelector(".modal-body").innerHTML = "Aucun contenu trouv\xe9";
                        else modal.querySelector(".modal-body").innerHTML = data;
                    }).catch((error)=>{
                        // Gérer les erreurs
                        console.error("Erreur lors de la requ\xeate AJAX:", error);
                    });
                }
                modalAlreadyOpen = postToDisplay;
                document.querySelector("body").classList.add("modal-open");
                modal.classList.add("open");
            });
        });
    }
    const closeBtn = document.querySelector(".modal-close");
    if (closeBtn) closeBtn.addEventListener("click", (event)=>{
        closeModal();
    });
    function closeModal() {
        // const modalParent = closeBtn.closest(".modal");
        modal.classList.remove("open");
        document.querySelector("body").classList.remove("modal-open");
        // Remove the event listener when the modal is closed
        modal.removeEventListener("click", closeModalOutside);
    }
    function closeModalOutside(event) {
        if (modal.querySelector(".modal-wrapper").contains(event.target) === false) closeModal();
    }
};



var $d2DXp = parcelRequire("d2DXp");
var $59cff6b9af2e68bb$exports = {};
"use strict";
Object.defineProperty($59cff6b9af2e68bb$exports, "__esModule", {
    value: true
});
var $59cff6b9af2e68bb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $59cff6b9af2e68bb$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * custom-select
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * A lightweight JS script for custom select creation.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Needs no dependencies.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * v0.0.1
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * (https://github.com/custom-select/custom-select)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright (c) 2016 Gionatan Lombardi & Marco Nucara
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * MIT License
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */ 
$59cff6b9af2e68bb$exports.default = $59cff6b9af2e68bb$var$customSelect;
// Polyfill for creating CustomEvents on IE9/10/11
// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill
try {
    var $cdadf9383efc3ff6$var$ce = new window.CustomEvent("test");
    $cdadf9383efc3ff6$var$ce.preventDefault();
    if ($cdadf9383efc3ff6$var$ce.defaultPrevented !== true) // IE has problems with .preventDefault() on custom events
    // http://stackoverflow.com/questions/23349191
    throw new Error("Could not prevent default");
} catch (e) {
    var $cdadf9383efc3ff6$var$CustomEvent = function(event, params) {
        var evt, origPrevent;
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        origPrevent = evt.preventDefault;
        evt.preventDefault = function() {
            origPrevent.call(this);
            try {
                Object.defineProperty(this, "defaultPrevented", {
                    get: function() {
                        return true;
                    }
                });
            } catch (e) {
                this.defaultPrevented = true;
            }
        };
        return evt;
    };
    $cdadf9383efc3ff6$var$CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = $cdadf9383efc3ff6$var$CustomEvent; // expose definition to window
}


var $59cff6b9af2e68bb$var$defaultParams = {
    containerClass: "custom-select-container",
    openerClass: "custom-select-opener",
    panelClass: "custom-select-panel",
    optionClass: "custom-select-option",
    optgroupClass: "custom-select-optgroup",
    isSelectedClass: "is-selected",
    hasFocusClass: "has-focus",
    isDisabledClass: "is-disabled",
    isOpenClass: "is-open"
};
function $59cff6b9af2e68bb$var$builder(el, builderParams) {
    var containerClass = "customSelect";
    var isOpen = false;
    var uId = "";
    var select = el;
    var container = void 0;
    var opener = void 0;
    var focusedElement = void 0;
    var selectedElement = void 0;
    var panel = void 0;
    var currLabel = void 0;
    var resetSearchTimeout = void 0;
    var searchKey = "";
    //
    // Inner Functions
    //
    // Sets the focused element with the neccessary classes substitutions
    function setFocusedElement(cstOption) {
        if (focusedElement) focusedElement.classList.remove(builderParams.hasFocusClass);
        if (typeof cstOption !== "undefined") {
            focusedElement = cstOption;
            focusedElement.classList.add(builderParams.hasFocusClass);
            // Offset update: checks if the focused element is in the visible part of the panelClass
            // if not dispatches a custom event
            if (isOpen) {
                if (cstOption.offsetTop < cstOption.offsetParent.scrollTop || cstOption.offsetTop > cstOption.offsetParent.scrollTop + cstOption.offsetParent.clientHeight - cstOption.clientHeight) cstOption.dispatchEvent(new CustomEvent("custom-select:focus-outside-panel", {
                    bubbles: true
                }));
            }
        } else focusedElement = undefined;
    }
    // Reassigns the focused and selected custom option
    // Updates the opener text
    // IMPORTANT: the setSelectedElement function doesn't change the select value!
    function setSelectedElement(cstOption) {
        if (selectedElement) {
            selectedElement.classList.remove(builderParams.isSelectedClass);
            selectedElement.removeAttribute("id");
            opener.removeAttribute("aria-activedescendant");
        }
        if (typeof cstOption !== "undefined") {
            cstOption.classList.add(builderParams.isSelectedClass);
            cstOption.setAttribute("id", containerClass + "-" + uId + "-selectedOption");
            opener.setAttribute("aria-activedescendant", containerClass + "-" + uId + "-selectedOption");
            selectedElement = cstOption;
            opener.children[0].textContent = selectedElement.customSelectOriginalOption.text;
        } else {
            selectedElement = undefined;
            opener.children[0].textContent = "";
        }
        setFocusedElement(cstOption);
    }
    function setValue(value) {
        // Gets the option with the provided value
        var toSelect = select.querySelector("option[value='" + value + "']");
        // If no option has the provided value get the first
        if (!toSelect) {
            var _select$options = $59cff6b9af2e68bb$var$_slicedToArray(select.options, 1);
            toSelect = _select$options[0];
        }
        // The option with the provided value becomes the selected one
        // And changes the select current value
        toSelect.selected = true;
        setSelectedElement(select.options[select.selectedIndex].customSelectCstOption);
    }
    function moveFocuesedElement(direction) {
        // Get all the .custom-select-options
        // Get the index of the current focused one
        var currentFocusedIndex = [].indexOf.call(select.options, focusedElement.customSelectOriginalOption);
        // If the next or prev custom option exist
        // Sets it as the new focused one
        if (select.options[currentFocusedIndex + direction]) setFocusedElement(select.options[currentFocusedIndex + direction].customSelectCstOption);
    }
    // Open/Close function (toggle)
    function open(bool1) {
        // Open
        if (bool1 || typeof bool1 === "undefined") {
            // If present closes an opened instance of the plugin
            // Only one at time can be open
            var openedCustomSelect = document.querySelector("." + containerClass + "." + builderParams.isOpenClass);
            if (openedCustomSelect) openedCustomSelect.customSelect.open = false;
            // Opens only the clicked one
            container.classList.add(builderParams.isOpenClass);
            // aria-expanded update
            container.classList.add(builderParams.isOpenClass);
            opener.setAttribute("aria-expanded", "true");
            // Updates the scrollTop position of the panel in relation with the focused option
            if (selectedElement) panel.scrollTop = selectedElement.offsetTop;
            // Dispatches the custom event open
            container.dispatchEvent(new CustomEvent("custom-select:open"));
            // Sets the global state
            isOpen = true;
        // Close
        } else {
            // Removes the css classes
            container.classList.remove(builderParams.isOpenClass);
            // aria-expanded update
            opener.setAttribute("aria-expanded", "false");
            // Sets the global state
            isOpen = false;
            // When closing the panel the focused custom option must be the selected one
            setFocusedElement(selectedElement);
            // Dispatches the custom event close
            container.dispatchEvent(new CustomEvent("custom-select:close"));
        }
        return isOpen;
    }
    function clickEvent(e) {
        // Opener click
        if (e.target === opener || opener.contains(e.target)) {
            if (isOpen) open(false);
            else open();
        } else if (e.target.classList && e.target.classList.contains(builderParams.optionClass) && panel.contains(e.target)) {
            setSelectedElement(e.target);
            // Sets the corrisponding select's option to selected updating the select's value too
            selectedElement.customSelectOriginalOption.selected = true;
            open(false);
            // Triggers the native change event of the select
            select.dispatchEvent(new CustomEvent("change"));
        // click on label or select (click on label corrispond to select click)
        } else if (e.target === select) // if the original select is focusable (for any external reason) let the focus
        // else trigger the focus on opener
        {
            if (opener !== document.activeElement && select !== document.activeElement) opener.focus();
        } else if (isOpen && !container.contains(e.target)) open(false);
    }
    function mouseoverEvent(e) {
        // On mouse move over and options it bacames the focused one
        if (e.target.classList && e.target.classList.contains(builderParams.optionClass)) setFocusedElement(e.target);
    }
    function keydownEvent(e) {
        if (!isOpen) // On "Arrow down", "Arrow up" and "Space" keys opens the panel
        {
            if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 32) open();
        } else switch(e.keyCode){
            case 13:
            case 32:
                // On "Enter" or "Space" selects the focused element as the selected one
                setSelectedElement(focusedElement);
                // Sets the corrisponding select's option to selected updating the select's value too
                selectedElement.customSelectOriginalOption.selected = true;
                // Triggers the native change event of the select
                select.dispatchEvent(new CustomEvent("change"));
                open(false);
                break;
            case 27:
                // On "Escape" closes the panel
                open(false);
                break;
            case 38:
                // On "Arrow up" set focus to the prev option if present
                moveFocuesedElement(-1);
                break;
            case 40:
                // On "Arrow down" set focus to the next option if present
                moveFocuesedElement(1);
                break;
            default:
                // search in panel (autocomplete)
                if (e.keyCode >= 48 && e.keyCode <= 90) {
                    // clear existing reset timeout
                    if (resetSearchTimeout) clearTimeout(resetSearchTimeout);
                    // reset timeout for empty search key
                    resetSearchTimeout = setTimeout(function() {
                        searchKey = "";
                    }, 1500);
                    // update search keyword appending the current key
                    searchKey += String.fromCharCode(e.keyCode);
                    // search the element
                    for(var i = 0, l = select.options.length; i < l; i++)// removed cause not supported by IE:
                    // if (options[i].text.startsWith(searchKey))
                    if (select.options[i].text.toUpperCase().substr(0, searchKey.length) === searchKey) {
                        setFocusedElement(select.options[i].customSelectCstOption);
                        break;
                    }
                }
                break;
        }
    }
    function changeEvent() {
        var index = select.selectedIndex;
        var element = index === -1 ? undefined : select.options[index].customSelectCstOption;
        setSelectedElement(element);
    }
    // When the option is outside the visible part of the opened panel, updates the scrollTop position
    // This is the default behaviour
    // To block it the plugin user must
    // add a "custom-select:focus-outside-panel" eventListener on the panel
    // with useCapture set to true
    // and stopPropagation
    function scrollToFocused(e) {
        var currPanel = e.currentTarget;
        var currOption = e.target;
        // Up
        if (currOption.offsetTop < currPanel.scrollTop) currPanel.scrollTop = currOption.offsetTop;
        else currPanel.scrollTop = currOption.offsetTop + currOption.clientHeight - currPanel.clientHeight;
    }
    function addEvents() {
        document.addEventListener("click", clickEvent);
        panel.addEventListener("mouseover", mouseoverEvent);
        panel.addEventListener("custom-select:focus-outside-panel", scrollToFocused);
        select.addEventListener("change", changeEvent);
        container.addEventListener("keydown", keydownEvent);
    }
    function removeEvents() {
        document.removeEventListener("click", clickEvent);
        panel.removeEventListener("mouseover", mouseoverEvent);
        panel.removeEventListener("custom-select:focus-outside-panel", scrollToFocused);
        select.removeEventListener("change", changeEvent);
        container.removeEventListener("keydown", keydownEvent);
    }
    function disabled(bool1) {
        if (bool1 && !select.disabled) {
            container.classList.add(builderParams.isDisabledClass);
            select.disabled = true;
            opener.removeAttribute("tabindex");
            container.dispatchEvent(new CustomEvent("custom-select:disabled"));
            removeEvents();
        } else if (!bool1 && select.disabled) {
            container.classList.remove(builderParams.isDisabledClass);
            select.disabled = false;
            opener.setAttribute("tabindex", "0");
            container.dispatchEvent(new CustomEvent("custom-select:enabled"));
            addEvents();
        }
    }
    // Form a given select children DOM tree (options and optgroup),
    // Creates the corresponding custom HTMLElements list (divs with different classes and attributes)
    function parseMarkup(children) {
        var nodeList = children;
        var cstList = [];
        if (typeof nodeList.length === "undefined") throw new TypeError("Invalid Argument");
        for(var i = 0, li = nodeList.length; i < li; i++){
            if (nodeList[i] instanceof HTMLElement && nodeList[i].tagName.toUpperCase() === "OPTGROUP") {
                var cstOptgroup = document.createElement("div");
                cstOptgroup.classList.add(builderParams.optgroupClass);
                cstOptgroup.setAttribute("data-label", nodeList[i].label);
                // IMPORTANT: Stores in a property of the created custom option group
                // a hook to the the corrisponding select's option group
                cstOptgroup.customSelectOriginalOptgroup = nodeList[i];
                // IMPORTANT: Stores in a property of select's option group
                // a hook to the created custom option group
                nodeList[i].customSelectCstOptgroup = cstOptgroup;
                var subNodes = parseMarkup(nodeList[i].children);
                for(var j = 0, lj = subNodes.length; j < lj; j++)cstOptgroup.appendChild(subNodes[j]);
                cstList.push(cstOptgroup);
            } else if (nodeList[i] instanceof HTMLElement && nodeList[i].tagName.toUpperCase() === "OPTION") {
                var cstOption = document.createElement("div");
                cstOption.classList.add(builderParams.optionClass);
                cstOption.textContent = nodeList[i].text;
                cstOption.setAttribute("data-value", nodeList[i].value);
                cstOption.setAttribute("role", "option");
                // IMPORTANT: Stores in a property of the created custom option
                // a hook to the the corrisponding select's option
                cstOption.customSelectOriginalOption = nodeList[i];
                // IMPORTANT: Stores in a property of select's option
                // a hook to the created custom option
                nodeList[i].customSelectCstOption = cstOption;
                // If the select's option is selected
                if (nodeList[i].selected) setSelectedElement(cstOption);
                cstList.push(cstOption);
            } else throw new TypeError("Invalid Argument");
        }
        return cstList;
    }
    function _append(nodePar, appendIntoOriginal, targetPar) {
        var target = void 0;
        if (typeof targetPar === "undefined" || targetPar === select) target = panel;
        else if (targetPar instanceof HTMLElement && targetPar.tagName.toUpperCase() === "OPTGROUP" && select.contains(targetPar)) target = targetPar.customSelectCstOptgroup;
        else throw new TypeError("Invalid Argument");
        // If the node provided is a single HTMLElement it is stored in an array
        var node = nodePar instanceof HTMLElement ? [
            nodePar
        ] : nodePar;
        // Injects the options|optgroup in the select
        if (appendIntoOriginal) {
            for(var i = 0, l = node.length; i < l; i++)if (target === panel) select.appendChild(node[i]);
            else target.customSelectOriginalOptgroup.appendChild(node[i]);
        }
        // The custom markup to append
        var markupToInsert = parseMarkup(node);
        // Injects the created DOM content in the panel
        for(var _i = 0, _l = markupToInsert.length; _i < _l; _i++)target.appendChild(markupToInsert[_i]);
        return node;
    }
    function _insertBefore(node, targetPar) {
        var target = void 0;
        if (targetPar instanceof HTMLElement && targetPar.tagName.toUpperCase() === "OPTION" && select.contains(targetPar)) target = targetPar.customSelectCstOption;
        else if (targetPar instanceof HTMLElement && targetPar.tagName.toUpperCase() === "OPTGROUP" && select.contains(targetPar)) target = targetPar.customSelectCstOptgroup;
        else throw new TypeError("Invalid Argument");
        // The custom markup to append
        var markupToInsert = parseMarkup(node.length ? node : [
            node
        ]);
        target.parentNode.insertBefore(markupToInsert[0], target);
        // Injects the option or optgroup node in the original select and returns the injected node
        return targetPar.parentNode.insertBefore(node.length ? node[0] : node, targetPar);
    }
    function remove(node) {
        var cstNode = void 0;
        if (node instanceof HTMLElement && node.tagName.toUpperCase() === "OPTION" && select.contains(node)) cstNode = node.customSelectCstOption;
        else if (node instanceof HTMLElement && node.tagName.toUpperCase() === "OPTGROUP" && select.contains(node)) cstNode = node.customSelectCstOptgroup;
        else throw new TypeError("Invalid Argument");
        cstNode.parentNode.removeChild(cstNode);
        var removedNode = node.parentNode.removeChild(node);
        changeEvent();
        return removedNode;
    }
    function empty() {
        var removed = [];
        while(select.children.length){
            panel.removeChild(panel.children[0]);
            removed.push(select.removeChild(select.children[0]));
        }
        setSelectedElement();
        return removed;
    }
    function destroy() {
        for(var i = 0, l = select.options.length; i < l; i++)delete select.options[i].customSelectCstOption;
        var optGroup = select.getElementsByTagName("optgroup");
        for(var _i2 = 0, _l2 = optGroup.length; _i2 < _l2; _i2++)delete optGroup.customSelectCstOptgroup;
        removeEvents();
        return container.parentNode.replaceChild(select, container);
    }
    //
    // Custom Select DOM tree creation
    //
    // Creates the container/wrapper
    container = document.createElement("div");
    container.classList.add(builderParams.containerClass, containerClass);
    // Creates the opener
    opener = document.createElement("span");
    opener.className = builderParams.openerClass;
    opener.setAttribute("role", "combobox");
    opener.setAttribute("aria-autocomplete", "list");
    opener.setAttribute("aria-expanded", "false");
    opener.innerHTML = "<span>\n   " + (select.selectedIndex !== -1 ? select.options[select.selectedIndex].text : "") + "\n   </span>";
    // Creates the panel
    // and injects the markup of the select inside
    // with some tag and attributes replacement
    panel = document.createElement("div");
    // Create random id
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for(var i = 0; i < 5; i++)uId += possible.charAt(Math.floor(Math.random() * possible.length));
    panel.id = containerClass + "-" + uId + "-panel";
    panel.className = builderParams.panelClass;
    panel.setAttribute("role", "listbox");
    opener.setAttribute("aria-owns", panel.id);
    _append(select.children, false);
    // Injects the container in the original DOM position of the select
    container.appendChild(opener);
    select.parentNode.replaceChild(container, select);
    container.appendChild(select);
    container.appendChild(panel);
    // ARIA labelledby - label
    if (document.querySelector('label[for="' + select.id + '"]')) currLabel = document.querySelector('label[for="' + select.id + '"]');
    else if (container.parentNode.tagName.toUpperCase() === "LABEL") currLabel = container.parentNode;
    if (typeof currLabel !== "undefined") {
        currLabel.setAttribute("id", containerClass + "-" + uId + "-label");
        opener.setAttribute("aria-labelledby", containerClass + "-" + uId + "-label");
    }
    // Event Init
    if (select.disabled) container.classList.add(builderParams.isDisabledClass);
    else {
        opener.setAttribute("tabindex", "0");
        select.setAttribute("tabindex", "-1");
        addEvents();
    }
    // Stores the plugin public exposed methods and properties, directly in the container HTMLElement
    container.customSelect = {
        get pluginOptions () {
            return builderParams;
        },
        get open () {
            return isOpen;
        },
        set open (bool){
            open(bool);
        },
        get disabled () {
            return select.disabled;
        },
        set disabled (bool){
            disabled(bool);
        },
        get value () {
            return select.value;
        },
        set value (val){
            setValue(val);
        },
        append: function append(node, target) {
            return _append(node, true, target);
        },
        insertBefore: function insertBefore(node, target) {
            return _insertBefore(node, target);
        },
        remove: remove,
        empty: empty,
        destroy: destroy,
        opener: opener,
        select: select,
        panel: panel,
        container: container
    };
    // Stores the plugin directly in the original select
    select.customSelect = container.customSelect;
    // Returns the plugin instance, with the public exposed methods and properties
    return container.customSelect;
}
function $59cff6b9af2e68bb$var$customSelect(element, customParams) {
    // Overrides the default options with the ones provided by the user
    var nodeList = [];
    var selects = [];
    return function init() {
        // The plugin is called on a single HTMLElement
        if (element && element instanceof HTMLElement && element.tagName.toUpperCase() === "SELECT") nodeList.push(element);
        else if (element && typeof element === "string") {
            var elementsList = document.querySelectorAll(element);
            for(var i = 0, l = elementsList.length; i < l; ++i)if (elementsList[i] instanceof HTMLElement && elementsList[i].tagName.toUpperCase() === "SELECT") nodeList.push(elementsList[i]);
        // The plugin is called on any HTMLElements list (NodeList, HTMLCollection, Array, etc.)
        } else if (element && element.length) {
            for(var _i3 = 0, _l3 = element.length; _i3 < _l3; ++_i3)if (element[_i3] instanceof HTMLElement && element[_i3].tagName.toUpperCase() === "SELECT") nodeList.push(element[_i3]);
        }
        // Launches the plugin over every HTMLElement
        // And stores every plugin instance
        for(var _i4 = 0, _l4 = nodeList.length; _i4 < _l4; ++_i4)selects.push($59cff6b9af2e68bb$var$builder(nodeList[_i4], $59cff6b9af2e68bb$var$_extends({}, $59cff6b9af2e68bb$var$defaultParams, customParams)));
        // Returns all plugin instances
        return selects;
    }();
}


addEventListener("DOMContentLoaded", (event)=>{
    document.documentElement.classList.remove("no-js");
    document.documentElement.classList.add("loaded");
    // play video on click
    const video = document.querySelector(".wp-block-cover video");
    if (video) document.documentElement.addEventListener("click", ()=>{
        document.querySelector(".wp-block-cover video").play();
    });
    (0, $e892be5f587a3385$export$2e2bcd8739ae039)();
    (0, $706c7076a3e32a08$export$2e2bcd8739ae039)();
    (0, $297cb9217e9cf27c$export$2e2bcd8739ae039)();
    (0, $1288651e9b55a7c9$export$96e4b36520c26a2c)();
    (0, $d2DXp.moveUpElements)();
    addEventListener("scroll", (event)=>{
        (0, $e892be5f587a3385$export$2e2bcd8739ae039)();
    });
    //custom select
    (0, (/*@__PURE__*/$parcel$interopDefault($59cff6b9af2e68bb$exports)))("select");
    // permet de faire en sorte qu'il n'y ai pas d'orphelin à la ligne
    const gutenberg_query = document.querySelectorAll(".query-one-line");
    if (gutenberg_query) gutenberg_query.forEach(function(item) {
        if (item.classList.contains("columns-4")) {
            if (item.childElementCount % 4 == 0) item.lastChild.classList.add("responsive-hidden");
        }
        if (item.classList.contains("columns-5")) {
            if (item.childElementCount % 5 == 0) item.lastChild.classList.add("responsive-hidden");
        }
        if (item.classList.contains("columns-3")) {
            if (item.childElementCount % 3 == 0) item.lastChild.classList.add("responsive-hidden");
        }
    });
    (0, $8965c4039d499022$export$2e2bcd8739ae039)();
});

})();
//# sourceMappingURL=index.js.map
